import { defineMessages } from 'react-intl';

export const messages: {
	exploreCategoriesHeading: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	exploreCategoriesDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	mitigateRiskHeading: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	mitigateRiskDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	nextButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	doneButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	progressIndicator: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	exploreCategoriesHeading: {
		defaultMessage: 'Explore risk by category',
		description: 'Heading for the first spotlight step about risk categories',
		id: 'alexstrasza.risk-assessment-spotlight.explore-categories.heading',
	},
	exploreCategoriesDescription: {
		defaultMessage:
			'Rovo Ops breaks down risk into categories. Select any category to see risk details, contributing factors, and why it was flagged.',
		description: 'Description for the first spotlight step about risk categories',
		id: 'alexstrasza.risk-assessment-spotlight.explore-categories.description',
	},
	mitigateRiskHeading: {
		defaultMessage: 'Mitigate risk',
		description: 'Heading for the second spotlight step about mitigation steps',
		id: 'alexstrasza.risk-assessment-spotlight.mitigate-risk.heading',
	},
	mitigateRiskDescription: {
		defaultMessage:
			'Get actionable mitigation steps tailored to each risk category, so you can address issues before the change goes live.',
		description: 'Description for the second spotlight step about mitigation steps',
		id: 'alexstrasza.risk-assessment-spotlight.mitigate-risk.description',
	},
	nextButton: {
		defaultMessage: 'Next',
		description: 'Button to go to the next spotlight step',
		id: 'alexstrasza.risk-assessment-spotlight.navigation.next',
	},
	doneButton: {
		defaultMessage: 'Done',
		description: 'Button to complete the spotlight tour',
		id: 'alexstrasza.risk-assessment-spotlight.navigation.done',
	},
	progressIndicator: {
		defaultMessage: '{currentStep} of {totalSteps}',
		description: 'Progress indicator showing current step and total steps',
		id: 'alexstrasza.risk-assessment-spotlight.navigation.progress',
	},
});
